import React from 'react';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';

export default function RoleRelationDialog({
  open,
  title,
  onCancel,
  onAccept,
  rows = [],
  columns = [],
  fileNameExport,
  maxWidth = 'lg',
  acceptText = 'Agregar',
  cancelText = 'Cerrar',
  children
}) {
  return (
    <CustomDialog
      maxWidth={maxWidth}
      fullWidth
      open={open}
      title={title}
      onCancel={onCancel}
      cancelText={cancelText}
      onAccept={onAccept}
      acceptText={acceptText}
    >
      {children}
      {children ? <br /> : null}
      <DataGridGenerico
        columns={columns}
        fileNameExport={fileNameExport}
        rows={rows}
        toolbar={false}
        totalCount={rows.length}
      />
    </CustomDialog>
  );
}
